// Deterministic PRNG for media filters.
//
// Same seed → identical infinite sequence in [0, 1). This is the contract every
// filter relies on so that {photoId, filterName} renders bit-stable for goldens
// (Plan v2 G4) and for the recap render path that re-runs the pipeline server-side.
//
// Algorithm: FNV-1a hash (string → uint32) feeds Mulberry32. Both are public-domain,
// fast, and well-suited for visual jitter — not for cryptographic use.

const FNV_OFFSET_BASIS = 0x811c9dc5
const FNV_PRIME = 0x01000193

function fnv1a(seed: string): number {
  let hash = FNV_OFFSET_BASIS
  for (let i = 0; i < seed.length; i++) {
    hash ^= seed.charCodeAt(i)
    // Math.imul keeps the multiplication in 32-bit space (JS numbers are float64).
    hash = Math.imul(hash, FNV_PRIME)
  }
  // Force unsigned 32-bit. >>> 0 is the canonical idiom.
  return hash >>> 0
}

export function seededRandom(seed: string): () => number {
  let state = fnv1a(seed)
  return () => {
    state = (state + 0x6d2b79f5) >>> 0
    let t = state
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}
